import { mapKeysToVariants, theme } from '@mirohq-internal/design-system';
import { Primitive, styled } from '@miro-site/ui-styled-engine';
var BoxStyled = styled(Primitive.div, {
  variants: {
    offset: mapKeysToVariants(theme['space-offset'], 'offset'),
    offsetY: mapKeysToVariants(theme['space-offset'], 'offsetY'),
    offsetX: mapKeysToVariants(theme['space-offset'], 'offsetX'),
    offsetTop: mapKeysToVariants(theme['space-offset'], 'offsetTop'),
    offsetBottom: mapKeysToVariants(theme['space-offset'], 'offsetBottom'),
    offsetLeft: mapKeysToVariants(theme['space-offset'], 'offsetLeft'),
    offsetRight: mapKeysToVariants(theme['space-offset'], 'offsetRight'),
    inset: mapKeysToVariants(theme['space-inset'], 'inset'),
    insetY: mapKeysToVariants(theme['space-inset'], 'insetY'),
    insetX: mapKeysToVariants(theme['space-inset'], 'insetX'),
    insetTop: mapKeysToVariants(theme['space-inset'], 'insetTop'),
    insetBottom: mapKeysToVariants(theme['space-inset'], 'insetBottom'),
    insetLeft: mapKeysToVariants(theme['space-inset'], 'insetLeft'),
    insetRight: mapKeysToVariants(theme['space-inset'], 'insetRight')
  }
});
export default BoxStyled;